import { render, staticRenderFns } from "./CustomerParameterContactInfoDialog.vue?vue&type=template&id=db909f0a&scoped=true&"
import script from "./CustomerParameterContactInfoDialog.vue?vue&type=script&lang=js&"
export * from "./CustomerParameterContactInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./CustomerParameterContactInfoDialog.vue?vue&type=style&index=0&id=db909f0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db909f0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VDialog})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
